import { manageGroup } from 'core/permissions';

export default {
  global: manageGroup,
  local: 'reporting.raw_report_local',
  local_managed: 'reporting.raw_report_local_managed',
};
